import { useCallback, useState } from 'react';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';

import { getExtraFilters } from '../productionBoard.utils';

export const useProductionBoard = () => {
  const [filters, setFilters] = useState({});
  const [widgetsValues, setWidgetsValues] = useState({});

  const handleLoadWidgetData = useCallback(keyValues => {
    setWidgetsValues(prev => ({ ...prev, ...keyValues }));
  }, []);

  const { state: yearsState } = useFetchWithStatusV2({
    endpoint: `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productionYearsAvailable}`,
    apiInstance: SECONDARY_API_CLIENT
  });
  const extraFilters = getExtraFilters(yearsState?.results?.years ?? []);

  const handleFiltersChange = selectedFilters => {
    setFilters(selectedFilters);
  };

  return {
    extraFilters,
    filters,
    handleLoadWidgetData,
    handleFiltersChange,
    widgetsValues
  };
};
